
export const VIEW_BLOCK = {
    header: 'header', // 顶部栏
    sideBar: 'sideBar', // 左侧目录树
    titleArea: 'titleArea', // 标题区域包括关联说明
    activityBar: 'activityBar', // 活动区域 点赞投币
    bottomBar: 'bottomBar', // 地步栏 标签 字数 投诉等
    bottomComment: 'bottomComment', // 底部评论区
    editorBottomArea: 'editorBottomArea', // 编辑器底部区域 推荐文档 相关文档等
    helperButton: 'helperButton', // 帮助悬浮按钮
    editorToolsButton: 'editorToolsButton', // 编辑器工具悬浮按钮
    wrapperMargin: 'wrapperMargin', // 知识库margin
    editorMargin: 'editorMargin', // 编辑器的边距
    editorOutLine: 'editorOutLine', // 编辑器大纲
    editorCardMode: 'editorCardMode', // 编辑器卡片模式
    editorUnderlineComment: 'editorUnderlineComment',
    editorShowNormalWidth: 'editorShowNormalWidth',
    editorPublishTip: 'editorPublishTip',
    flexBuilderShowNormalMode: 'flexBuilderShowNormalMode', // 随心搭正常模式展示
    editorRadius: 'editorRadius', // 编辑器圆角
    editorLinkProxy: 'editorLinkProxy', // 编辑器圆角
    docTemplate: 'docTemplate', // 文档模版
};

export const QUERY = {
    view: 'view',
    viewMode: 'viewmode',
};

export const VIEW_TYPE = {
    onlyContent: 'onlycontent',
    sideBar: 'sidebar',
};
